import {colorStyleMap} from '@/utilities/color-style-map';
import classNames from 'classnames';

export default function RadioButtonIcon({
  selected = false,
  color,
}: RadioButtonIconProps) {
  const colorStyle = colorStyleMap.get(color ?? '');
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Type=Radio, Color=Green, Active=true">
        <rect
          x="0.75"
          y="0.75"
          width="14.5"
          height="14.5"
          rx="7.25"
          strokeWidth="1.5"
          className={colorStyle?.stroke ?? 'stroke-neutral-baby-blue'}
        />
        <circle
          id="radio"
          cx="8"
          cy="8"
          r="5"
          className={classNames(
            'origin-center fast-transition',
            colorStyle?.fill ?? 'fill-primary-blue',
            {
              'scale-70 opacity-0': !selected,
              'opacity-1 scale-100': selected,
            }
          )}
        />
      </g>
    </svg>
  );
}

/**
 * The props for the checkbox icon.
 * @param selected - whether the checkbox is selected
 * @param color - the color
 */
type RadioButtonIconProps = {
  selected?: boolean;
  color?: string;
};
